import React from 'react';
import { Badge } from 'reactstrap';
import { formatCurrency } from '../../../../../utils/format';
import { FINANCIAL_STATUS, FINANCIAL_SOURCES } from '../../../../../constants/financial';

export const getFinancialColumns = ({ formatDate, onViewSale }) => [
    {
        label: 'Categoria / Descrição',
        key: 'categoryName',
        render: (row) => (
            <div>
                <span className="d-block fw-bold text-dark">{row.categoryName || 'Lançamento'}</span>
                {row.notes && <small className="text-muted text-truncate d-block" style={{ maxWidth: '200px' }}>{row.notes}</small>}
            </div>
        )
    },
    {
        label: 'Origem / Entidade',
        key: 'entityName',
        render: (row) => (
            <div>
                <span className="d-block fw-semibold text-muted font-size-12">{row.sourceType === FINANCIAL_SOURCES.MEMBER ? 'Aluno' : row.sourceType || 'Outro'}</span>
                <span className="text-dark">{row.entityName || '-'}</span>
            </div>
        )
    },
    {
        label: 'Vencimento',
        key: 'dueDate',
        render: (row) => (
            <span className={`fw-semibold ${row.status === FINANCIAL_STATUS.OVERDUE ? 'text-danger' : 'text-dark'}`}>
                {formatDate(row.dueDate)}
            </span>
        )
    },
    {
        label: 'Pagamento',
        key: 'paymentDate',
        render: (row) => (
            <div className="d-flex flex-column">
                <span className="text-dark">{row.paymentDate ? formatDate(row.paymentDate) : '-'}</span>
                {row.paymentMethod && <small className="text-muted">{row.paymentMethod}</small>}
            </div>
        )
    },
    {
        label: 'Valor Líquido',
        key: 'netAmount',
        style: { textAlign: 'right' },
        cellStyle: { textAlign: 'right' },
        render: (row) => (
            <span className="fw-bold text-primary">
                {formatCurrency(row.netAmount)}
            </span>
        )
    },
    {
        label: 'Vendedor',
        key: 'employeeName',
        render: (row) => (
            <span className="text-muted font-size-12">
                {row.employeeName || '-'}
            </span>
        )
    },
    {
        label: 'Status',
        key: 'status',
        render: (row) => {
            const statusMap = {
                [FINANCIAL_STATUS.PENDING]: { color: 'warning', label: 'Pendente' },
                [FINANCIAL_STATUS.PAID]: { color: 'success', label: 'Pago' },
                [FINANCIAL_STATUS.OVERDUE]: { color: 'danger', label: 'Atrasado' },
                [FINANCIAL_STATUS.CANCELED]: { color: 'secondary', label: 'Cancelado' },
                'REFUNDED': { color: 'info', label: 'Reembolsado' }
            };
            const statusObj = statusMap[row.status] || { color: 'dark', label: row.status };
            return <Badge color={statusObj.color} pill className="font-size-11 px-2 py-1">{statusObj.label}</Badge>;
        }
    },
    {
        label: 'Ações',
        key: 'actions',
        style: { textAlign: 'center', width: '80px' },
        cellStyle: { textAlign: 'center' },
        render: (row) => (
            <button 
                className="btn btn-soft-info btn-sm border-0 rounded-0 d-flex align-items-center justify-content-center mx-auto"
                style={{ width: '32px', height: '32px' }}
                onClick={() => onViewSale?.(row)}
                title="Ver Detalhes da Venda"
                disabled={!row.idSale}
            >
                <i className="mdi mdi-eye-outline font-size-16"></i>
            </button>
        )
    }
];
